import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { steps, BOOKING_URL } from '../mock';

export default function HowItWorks() {
  const [active, setActive] = useState(0);
  const step = steps[active];

  return (
    <section id="how-it-works" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#ea580c] mb-4 font-semibold">How it works</p>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-[#0b0f0d] leading-tight">
            Four moves from cold market to full crew calendar.
          </h2>
        </div>

        <div className="flex flex-wrap gap-3 mb-10">
          {steps.map((s, i) => (
            <button
              key={s.key}
              onClick={() => setActive(i)}
              className={`inline-flex items-center gap-3 px-5 py-3 rounded-full border font-display font-semibold ${
                active === i
                  ? 'bg-[#0b0f0d] text-white border-[#0b0f0d]'
                  : 'bg-white text-[#0b0f0d] border-[#e8e4d8] hover:border-[#0b0f0d]/40'
              }`}
            >
              <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs ${
                active === i ? 'bg-[#ea580c] text-white' : 'bg-[#0b0f0d]/8 text-[#0b0f0d]'
              }`}>{s.n}</span>
              {s.title}
            </button>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <h3 className="font-display text-2xl md:text-4xl font-semibold text-[#0b0f0d] leading-tight">{step.headline}</h3>
            <p className="mt-5 text-[#4a4f4c] text-lg leading-relaxed">{step.body}</p>
            <div className="mt-8 space-y-3">
              {step.bullets.map((b) => (
                <div key={b} className="flex items-start gap-3">
                  <div className="mt-1 w-5 h-5 rounded-full bg-[#0b0f0d] flex items-center justify-center text-white">
                    <Check size={12} />
                  </div>
                  <span className="text-[#0b0f0d]">{b}</span>
                </div>
              ))}
            </div>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="mt-10 inline-flex bg-[#0b0f0d] hover:bg-[#1a1f1c] text-white font-semibold px-6 py-3 rounded-full">
              Book a Free Call
            </a>
          </div>

          <div className="relative">
            <div className="aspect-square max-w-md mx-auto rounded-3xl border border-[#e8e4d8] bg-white p-8 relative overflow-hidden shadow-xl shadow-[#0b0f0d]/5">
              <div className="absolute -top-20 -right-20 w-60 h-60 bg-[#ea580c]/12 rounded-full blur-3xl" />
              <div className="absolute inset-0 dot-grid opacity-50" />
              <div className="relative flex items-center justify-center h-full">
                <div className="text-center">
                  <div className="font-display text-[150px] leading-none font-semibold text-[#0b0f0d]">0<span className="text-[#ea580c]">{step.n}</span></div>
                  <div className="mt-4 text-[#0b0f0d] font-display font-semibold text-2xl uppercase tracking-widest">{step.title}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
